/* prettier-ignore */

import { Component, inject } from '@angular/core';
import { catchError, of, throwError } from 'rxjs';
import { SendUpdateRouteService } from 'src/app/pages/send-update-route/send-update-route.service';
import Swal from'sweetalert2';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'header-tech-update',
  templateUrl: './tech-update-route.component.html',
  styleUrl: './tech-update-route.component.scss',
})

export class HeaderTechUpdateRouteComponent {
  private _translationService = inject(TranslationService);

    constructor(
        private sendUpdateService: SendUpdateRouteService,
    ) {}

    updateRoute(){
        this.sendUpdateService.updatedRoute()
            .pipe(
                catchError((err) => {
                    Swal.fire({ icon: 'error', title: '', text: this._translationService.instant('Ha ocurrido un error al actualizar la ruta') })
                    return throwError(() => new Error('HTTP request failed', { cause: err }));
                }),
            )
            .subscribe(response => {
                Swal.fire({
                    title: '',
                    text: this._translationService.instant('La ruta ha sido actualizada'),
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    timer: 2500,
                    timerProgressBar: true,
                })
            });
    }


}